import { domainProvider } from '@mathflat/shared/@common/domain/domainProvider'
import type { AxiosError, AxiosResponse } from 'axios'
import axios from 'axios'
import qs from 'qs'

import type { StrapiArrayResponse, StrapiError } from '@/types/common/api'

import { envUtils } from '../envUtils'
import { _mixpanelUtils } from '../trackings/_mixpanel'

const getBaseURL = () => {
  if (envUtils.localStrapiApiUrl) {
    return envUtils.localStrapiApiUrl
  }

  if (envUtils.isLive) {
    return `https://hcms.${domainProvider.TARGET_DOMAIN}/api`
  }
  return `https://hcms-staging.${domainProvider.TARGET_DOMAIN}/api`
}

const strapi = axios.create({
  baseURL: getBaseURL(),
  params: {
    populate: '*',
  },
  paramsSerializer: (params) => qs.stringify(params),
})

strapi.interceptors.request.use((config) => {
  if (config.url?.match(/\?/g)) {
    throw Error('url에 parameter string넣지 말아주세요.')
  }

  return config
})

strapi.interceptors.response.use(
  (response: AxiosResponse<StrapiArrayResponse<any>>) => {
    _mixpanelUtils.strapiTrack(response)
    return response
  },
  (error: AxiosError<StrapiError>) => {
    _mixpanelUtils.strapiErrorTrack(error)
    return Promise.reject(error)
  },
)

export default strapi
